/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddUserCertificateCommand } from '../models/AddUserCertificateCommand';
import type { ResponseData_Array_UserCertificateResponse } from '../models/ResponseData_Array_UserCertificateResponse';
import type { ResponseData_Boolean } from '../models/ResponseData_Boolean';
import type { ResponseData_UserResponse } from '../models/ResponseData_UserResponse';
import type { UpdateCurrentUserCommand } from '../models/UpdateCurrentUserCommand';
import type { UpdateCurrentUserTwoFactorCommand } from '../models/UpdateCurrentUserTwoFactorCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Получить информацию о пользователе
     * @returns ResponseData_UserResponse OK
     * @throws ApiError
     */
    public static getApiV1User(): CancelablePromise<ResponseData_UserResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/user',
        });
    }
    /**
     * Обновить данные пользователя
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static putApiV1User({
        requestBody,
    }: {
        requestBody?: UpdateCurrentUserCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/user',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Получить информацию о сертификатах
     * @returns ResponseData_Array_UserCertificateResponse OK
     * @throws ApiError
     */
    public static postApiV1UserCertificates(): CancelablePromise<ResponseData_Array_UserCertificateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user/certificates',
        });
    }
    /**
     * Добавить сертификат
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static postApiV1UserCertificate({
        requestBody,
    }: {
        requestBody?: AddUserCertificateCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/user/certificate',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Обновить данные 2FA
     * @returns ResponseData_Boolean OK
     * @throws ApiError
     */
    public static putApiV1UserTwoFactor({
        requestBody,
    }: {
        requestBody?: UpdateCurrentUserTwoFactorCommand,
    }): CancelablePromise<ResponseData_Boolean> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/user/twoFactor',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
